module.exports = __webpack_public_path__ + "img/print_official@2x.0632d663.png";